<template>
  <div class="categories">
    <GridCategoriesButtons
      v-if="disciplines.length > 0"
      :parent-display-type="category.displayType"
      :categories="disciplines"
      slug="discilpines"
    />
    <GridCategoriesButtons
      v-for="cat in interDisciplines"
      :key="cat.id"
      :parent-display-type="category.displayType"
      :categories="cat.children"
      :title="cat.title"
      :slug="cat.slug"
    />
  </div>
</template>
<script lang="ts" setup>
const {
  categoryManager: { category },
} = inject(INJECT_CATEGORY_PAGE);

const disciplines = computed(() => {
  return category.value.children.filter(
    (child) =>
      child.contentType === ContentTypes.SuperDiscipline ||
      child.contentType === ContentTypes.SubDiscipline ||
      child.contentType === ContentTypes.Discipline ||
      child.contentType === ContentTypes.DisciplineSection ||
      child.contentType === ContentTypes.Extra ||
      child.contentType === ContentTypes.Testing ||
      child.contentType === ContentTypes.Exam
  );
});
const interDisciplines = computed(() => {
  return category.value.children.filter(
    (child) => child.contentType === ContentTypes.InterDiscipline
  );
});
</script>
<style lang="scss" scoped>
.categories {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
</style>
